export const formatUSD = (amount: number) => {
	return new Intl.NumberFormat('en-US').format(amount);
};
